<template>
  <div id="root" style="width: 100%; height: 100%">
    <div id="forgeViewer" style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
import { viewerInit } from '@/utils/viewInit'
import { mapGetters } from 'vuex'
export default {
  props: {
    modelPath: String,
    pdfPage: Number,
  },
  data() {
    return {
      viewer: {},
    }
  },
  mounted() {
    this.makeModel(this.pdfPage, () => {
      console.log('模型加载完成')
    })
    // window.addEventListener('resize', this.resizeEvent())
  },
  destroyed() {
    // window.removeEventListener('resize', this.resizeEvent())
  },
  watch: {
    pdfPage(to, from) {},
  },
  methods: {
    resizeEvent() {
      // console.log('resize')
    },
    reloadModel(page, cb) {
      var forgeViewer = document.getElementById('forgeViewer')
      var root = document.getElementById('root')
      forgeViewer.remove()
      var newforgeViewer = document.createElement('div')
      newforgeViewer.setAttribute('id', 'forgeViewer')
      newforgeViewer.setAttribute('style', 'width:100%;height:100%')
      root.appendChild(newforgeViewer)
      this.makeModel(page, cb)
    },
    makeModel(page, cb) {
      var _this = this
      viewerInit(this.modelPath, page, document.getElementById('forgeViewer'), function (viewer) {
        _this.$emit('modelLoaded', viewer)
        cb()
      })
    },
  },
}
</script>

<style>
.adsk-viewing-viewer {
  width: calc(55% - 10px) !important;
}
</style>
